import { TLocalizationMessages } from 'types/i18n';
import { brand, releaseTagRef } from 'utils/environment';
import logger from 'utils/logger';

import { BASE_LOCALE } from './constants';

const BASE_URL = `https://intl-prod-${brand()}-cdn.rbictg.com/locales`;

const getLocaleUrl = (locale: string) => {
  return `${BASE_URL}/${locale}.${releaseTagRef}.json`;
};

const fetchLocale = async (locale: string): Promise<TLocalizationMessages> => {
  const url = getLocaleUrl(locale);
  const response = await fetch(url);
  return await response.json();
};

async function getMessagesFromBundle(
  language: string,
  country: string
): Promise<TLocalizationMessages> {
  try {
    return await import(`state/translations/${language}_${country}.json`);
  } catch (e) {
    logger.warn(e);
  }

  return await import(`state/translations/${BASE_LOCALE}.json`);
}

async function getMessagesFromCdn(
  language: string,
  country: string
): Promise<TLocalizationMessages> {
  const locales = [`${language}-${country}`, BASE_LOCALE];

  for (const locale of locales) {
    try {
      return await fetchLocale(locale);
    } catch (e) {
      logger.warn(e);
    }
  }

  // Fall back to bundle messages
  return await getMessagesFromBundle(language, country);
}

interface IGetMessagesForLanguageArgs {
  language: string;
  country: string;
  shouldUseCdn: boolean;
}

export async function getMessagesForLanguage({
  language,
  country,
  shouldUseCdn,
}: IGetMessagesForLanguageArgs) {
  return shouldUseCdn
    ? getMessagesFromCdn(language, country)
    : getMessagesFromBundle(language, country);
}
